import React from 'react'
import { useGetDriverStatisticsQuery } from '../../redux/services/DriverService'

const DriverStatistics = ({ id }) => {
    const { data: data2, isLoading, isFetching, refetch } = useGetDriverStatisticsQuery(id)
    const statistic = data2?.response?.data
    return (
        <>

            <div class="single-data mt-2">
                <h4 class="text-left mb-4">Total Statistics</h4>
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="card bg-primary tx-fixed-white card-bg-img">
                            <a class="card-body text-decoration-none position-relative d-flex justify-content-between">
                                <div>
                                    <div class="flex-grow-1">
                                        <p class="mb-4 fs-18 fw-semibold text-white">Trips</p>
                                    </div><span class="fs text-white">{statistic?.total?.jobs || 0}</span>
                                </div>
                                <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="card bg-success tx-fixed-white card-bg-img">
                            <a class="card-body position-relative d-flex justify-content-between">
                                <div>
                                    <div class="flex-grow-1">
                                        <p class="mb-4 fs-18 fw-semibold text-white">Expenses</p>
                                    </div><span class="fs text-white">{statistic?.total?.expense || 0}</span>
                                </div>
                                <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="card bg-warning tx-fixed-white card-bg-img">
                            <a class="card-body position-relative d-flex justify-content-between">
                                <div>
                                    <div class="flex-grow-1">
                                        <p class="mb-4 fs-18 fw-semibold text-white">Net Earning</p>
                                    </div><span class="fs text-white">{statistic?.total?.net_earning || 0}</span>
                                </div>
                                <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="card bg-info tx-fixed-white card-bg-img">
                            <a class="card-body position-relative d-flex justify-content-between">
                                <div>
                                    <div class="flex-grow-1">
                                        <p class="mb-4 fs-18 fw-semibold text-white">Dues Payment</p>
                                    </div><span class="fs text-white">{statistic?.total?.due_payment || 0}</span>
                                </div>
                                <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-data mt-2">
                <h4 class="text-left mb-4">Monthly Statistics</h4>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 ">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Total Trips</p><span class="fs-5">{statistic?.monthly?.jobs || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-primary-transparent text-primary"><i class="fe  fs-18">$</i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 ">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Expenses</p><span class="fs-5">{statistic?.monthly?.expense || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-secondary-transparent text-secondary"><i class="fe fe-package fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Net Earning</p><span class="fs-5">{statistic?.monthly?.net_earning || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-warning-transparent text-warning"><i class="fe fe-user fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Due Payments</p><span class="fs-5">{statistic?.monthly?.due_payment || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-warning-transparent text-warning"><i class="fe fe-user fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-data mt-2">
                <h4 class="text-left mb-4">Weekly Statistics</h4>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 ">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Total Trips</p><span class="fs-5">{statistic?.weekly?.jobs || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-primary-transparent text-primary"><i class="fe  fs-18">$</i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 ">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Expenses</p><span class="fs-5">{statistic?.weekly?.expense || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-secondary-transparent text-secondary"><i class="fe fe-package fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Net Earning</p><span class="fs-5">{statistic?.weekly?.net_earning || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-warning-transparent text-warning"><i class="fe fe-user fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card border">
                            <div class="card-body">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">Due Payments</p><span class="fs-5">{statistic?.weekly?.due_payment || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-warning-transparent text-warning"><i class="fe fe-user fs-18"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DriverStatistics